import { ca } from '@cian/analytics';

import { EType } from '../../types/villagePromotions';

interface IClick {
  id: number;
  type: string;
  actionPosition: number;
  actionId: number;
}

interface IActionsList {
  action_id: number;
  action_type: EType;
  action_position: number;
}

interface IShowClick {
  id: number;
  actionsList: IActionsList[];
}

export function trackPromoClick({ id, type, actionPosition, actionId }: IClick) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Click_promo_card',
    label: `${type}_${actionId}_${actionPosition}`,
    products: [
      {
        id,
        extra: { action_id: actionId, action_type: type, action_position: actionPosition },
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}

export function trackShowMoreClick({ id, actionsList }: IShowClick) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Click_show_more_actions',
    label: '',
    products: [
      {
        id,
        extra: {
          actions_list: actionsList,
        },
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}

export function trackScrollOnPromos({ id, actionsList }: IShowClick) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Scroll_actions_block_shown',
    label: '',
    products: [
      {
        id,
        extra: {
          actions_list: actionsList,
        },
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}

export function trackContactButtonClick({ id, type, actionPosition, actionId }: IClick) {
  ca('eventEbc', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_card_promo_card',
    label: '',
    products: [
      {
        id,
        extra: { action_id: actionId, action_type: type, action_position: actionPosition },
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}
